<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <header
    v-if="hasContent"
    class="sticky top-0 z-40 transition-all duration-300">

    <div 
      class="absolute inset-0 bg-[var(--color-bg)]/50 backdrop-blur-xs"
      style="-webkit-mask-image: linear-gradient(to bottom, black 70%, transparent 100%);
             mask-image: linear-gradient(to bottom, black 70%, transparent 100%);">
    </div>

    <div class="relative z-10 flex items-center justify-center px-4 pt-4 pb-3">
      
      <div v-if="header.showBack" class="absolute left-4">
        <BackButton />
      </div>

      <div class="text-center">
        <h1 class="text-xl font-bold tracking-tight">
          {{ header.title }}
        </h1>
        <p
          v-if="header.subtitle"
          class="text-xs font-medium opacity-60 font-mono tracking-wide mt-0.5">
          {{ header.subtitle }}
        </p>
      </div>

      <div v-if="header.showAdd" class="absolute right-4">
        <button
          @click="header.addAction?.()"
          class="p-2 rounded-xl border border-[var(--color-text)]/30 text-[var(--color-text)] 
                 hover:bg-[var(--color-text)]/5 hover:border-[var(--color-text)]/60 
                 active:scale-95
                 transition-all duration-200 flex items-center justify-center shadow-sm">
          <Plus class="w-5 h-5 stroke-[2.5]" />
        </button>
      </div>
    </div>
  </header>
</template>

<script setup>
import { computed } from 'vue'
import { Plus } from 'lucide-vue-next'
import BackButton from '@/components/ui/buttons/GetBackButton.vue'
import { useUiStore } from '@/stores/ui.store'

const ui = useUiStore()

const header = computed(() => ui.header)

const hasContent = computed(() =>
  header.value.title ||
  header.value.showBack ||
  header.value.showAdd
)
</script>